// IDs are hardcoded on the backend, should be fine to do the same here
export const DEFAULT_SWARMIO_CURRENCY_ID: string =
  '0e675574-daf0-11e9-8a34-2a2ae2dbcce4';
export const SHINY_SWARMIO_CURRENCY_ID: string =
  '0e6757d6-daf0-11e9-8a34-2a2ae2dbcce4';
